// @ vendors
const { Promise } = require('es6-promise');

// @ helpers
const { APIGet, APIPost, base64ToBlob } = require('utilities/APIRequestHelper');
const apiURLBuilder = require('core/apiURLBuilder');
const { getLanguage } = require('core/i18n').i18n;
const getExtension = require('utilities/mimeTypeToExt');
const { openPDFViewer, showPDFFailure } = require('utilities/contactCenter/pdfViewer');

// @ constants
const {
    CONTENT_TYPE_PDF,
    DOCUMENT_TYPES: { POLICY }
} = require('../../insuranceConstants/insuranceRequestHome');
const { VIEWER } = require('constants/contactCenter/pdfViewer');
const {
    INSURANCE_REQUEST_GET_DOCUMENT_REQUEST,
    INSURANCE_REQUEST_GET_DOCUMENT_SUCCESS,
    INSURANCE_REQUEST_GET_DOCUMENT_FAILURE,
    INSURANCE_REQUEST_LOAD_DOCUMENTS_FOR_PREVIEW,
    INSURANCE_REQUEST_POST_POLICY_PDF,
    INSURANCE_REQUEST_SEND_BUDGET_EMAIL_REQUEST,
    INSURANCE_REQUEST_SEND_BUDGET_EMAIL_SUCCESS,
    INSURANCE_REQUEST_SEND_BUDGET_EMAIL_FAILURE,
    INSURANCE_REQUEST_DOCUMENT_READ,
} = require('../../insuranceConstants/actionTypes');

const loadDocumentsForPreview = isFetching => ({
    type: INSURANCE_REQUEST_LOAD_DOCUMENTS_FOR_PREVIEW,
    data: { isFetching }
});

const getDocumentRequest = docType => ({
    type: INSURANCE_REQUEST_GET_DOCUMENT_REQUEST,
    data: { docType }
});

const getDocumentSuccess = docType => ({
    type: INSURANCE_REQUEST_GET_DOCUMENT_SUCCESS,
    data: { docType }
});

const getDocumentFailure = (docType, error) => ({
    type: INSURANCE_REQUEST_GET_DOCUMENT_FAILURE,
    data: {
        docType,
        error
    }
});

const sendBudgetEmailRequest = () => ({
    type: INSURANCE_REQUEST_SEND_BUDGET_EMAIL_REQUEST
});

const sendBudgetEmailSuccess = () => ({
    type: INSURANCE_REQUEST_SEND_BUDGET_EMAIL_SUCCESS
});

const sendBudgetEmailFailure = error => ({
    type: INSURANCE_REQUEST_SEND_BUDGET_EMAIL_FAILURE,
    data: { error }
});

const saveBase64Policy = base64Response => ({
    type: INSURANCE_REQUEST_POST_POLICY_PDF,
    data: { base64Response }
});

const b64toBlob = (b64Data, typeContent) => {
    const byteCharacters = atob(b64Data);
    let byteArrays = [];
    for (let offset = 0; offset < byteCharacters.length; offset += 512) {
        const slice = byteCharacters.slice(offset, offset + 512),
            byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i)
        }
        const byteArray = new Uint8Array(byteNumbers);

        byteArrays.push(byteArray)
    }
    const blob = new Blob(byteArrays, { type: typeContent });
    return blob
};

const handleOpenWindow = (base64string) => {
    const data = base64ToBlob(base64string);
    if (__CONTACT_CENTER__) {
        openPDFViewer(data);
    } else {
        const blobObject = new Blob([data], { type: CONTENT_TYPE_PDF });
        const urlBase64 = window.URL.createObjectURL(blobObject);
        window.open(urlBase64);
    }
}

const getDocument = (docType, docName, loadType) => (dispatch, getState) => {
    const currentState = getState().insuranceRequestState.get('data');
    if (currentState.get('id')) {
        dispatch(loadDocumentsForPreview(true));
        dispatch(getDocumentRequest(docType));
        const requestData = {
            query: {
                documentType: docType,
                language: getLanguage().toUpperCase()
            }
        };
        return APIGet(
            dispatch,
            apiURLBuilder.getURL('insuranceRequestDocument', { id: currentState.get('id') }),
            requestData
        )
            .then(response => {
                const { documentFile } = response.data;
                const { base64, filename, contentType } = documentFile;
                const fileExtension = getExtension(contentType);
                const docNamePdf = `${docName}.${fileExtension}`;
                const base64string = `data:${contentType};base64,${base64}`;
                if (docType === POLICY) {
                    const base64url = URL.createObjectURL(b64toBlob(base64, filename)) + '#toolbar=0&navpanes=0&scrollbar=0'
                    const formatBaseResponse = {
                        base64url,
                        base64string,
                        base64type: contentType,
                        base64name: docNamePdf,

                    };
                    dispatch(saveBase64Policy(formatBaseResponse))
                } else {
                    handleOpenWindow(base64string)
                    dispatch(getDocumentSuccess(docType, response.data));
                    dispatch(loadDocumentsForPreview(false));
                }
            })
            .catch(response => {
                if (loadType === VIEWER) {
                    showPDFFailure();
                }
                if (!!response.error) {
                    dispatch(getDocumentFailure(docType));
                } else {
                    throw response;
                }
            });
    }
};

const sendBudgetEmail = () => (dispatch, getState) => {
    const currentState = getState().insuranceRequestState.get('data');

    if (currentState.get('id')) {
        dispatch(sendBudgetEmailRequest());

        return APIPost(
            dispatch,
            apiURLBuilder.getURL('insuranceSendBudgetEmail', {
                id: currentState.get('id'),
                lang: getLanguage().toUpperCase()
            })
        )
            .then(response => dispatch(sendBudgetEmailSuccess(response)))
            .catch(response => {
                if (!!response.error) {
                    dispatch(sendBudgetEmailFailure(response.error));
                } else {
                    throw response;
                }
            });

    } else {
        return Promise.resolve();
    }
};

const checkReadDocument = () => (dispatch) => {
        dispatch({
            type: INSURANCE_REQUEST_DOCUMENT_READ,
            data: true
        });
    }


module.exports = {
    getDocument,
    sendBudgetEmail,
    checkReadDocument,
};
